module.exports = __webpack_public_path__ + "fonts/unicredit-bolditalic.47cd888f.woff";